import IncentivesMarketNotifications from 'modules/incentivesMarket/pages/IncentivesMarketNotifications';
import { IncentivesMarketProvider } from '../contexts/IncentivesMarketContext';

const IncentivesMarketNotificationsContainer = () => (
  <IncentivesMarketProvider>
    <IncentivesMarketNotifications />
  </IncentivesMarketProvider>
);

export default IncentivesMarketNotificationsContainer;
